/**
 * useModoEscuro — mesmo contrato do darkModeToggle() do Jinja: classe
 * `dark` no <html> + chave `darkMode` no localStorage (a preferência
 * atravessa os dois mundos durante a migração).
 */

import { useCallback, useEffect, useState } from 'react'

function estaEscuro() {
  return document.documentElement.classList.contains('dark')
}

export function useModoEscuro() {
  const [escuro, setEscuro] = useState(estaEscuro)

  useEffect(() => {
    document.documentElement.classList.toggle('dark', escuro)
    localStorage.setItem('darkMode', String(escuro))
  }, [escuro])

  const alternar = useCallback(() => setEscuro((v) => !v), [])
  return { escuro, alternar }
}
